import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export function EmptyResource({ brandId, resource }: { brandId: string; resource: string }) {
  const map: Record<string, { title: string; body: string; href: string; cta: string }> = {
    "personas": {
      title: "No personas yet",
      body: "Add at least one persona before drafting a landing page.",
      href: `/brands/${brandId}/personas`,
      cta: "Go to Personas",
    },
    "products": {
      title: "No products yet",
      body: "Add a product before drafting a landing page.",
      href: `/brands/${brandId}/products`,
      cta: "Go to Products",
    },
    "angles": {
      title: "No narrative angles yet",
      body: "Generate or save at least one narrative angle for this brand.",
      href: `/brands/${brandId}/narratives`,
      cta: "Go to Narrative Engine",
    },
  };
  const info = map[resource] ?? map["personas"];
  return (
    <Card className="p-8 text-center space-y-4">
      <h2 className="text-base font-semibold">{info.title}</h2>
      <p className="text-sm text-muted-foreground">{info.body}</p>
      <Link href={info.href}>
        <Button variant="default" data-testid="button-empty-cta">{info.cta}</Button>
      </Link>
    </Card>
  );
}